// extracted by mini-css-extract-plugin
module.exports = {"tabs__header":"Tabs_tabs__header__3wusF","marginRight":"Tabs_marginRight__3PQ_n","isHideTab":"Tabs_isHideTab__1EU-n"};